export default "assets/images/icons/circle-b4c28a16.svg";